import { activeClients, clientsWithLogos } from "@/data/clients";
import ClientLogo from "@/components/ClientLogo";

/**
 * Horizontal client marquee. Renders only clients with logos.
 * If no logos are available, shows text plates for active clients.
 * Respects prefers-reduced-motion.
 */
export default function ClientMarquee() {
  const withLogos = clientsWithLogos();
  const list = withLogos.length ? withLogos : activeClients();
  if (!list.length) return null;

  // Duplicate the list so the CSS keyframes can loop seamlessly.
  const track = [...list, ...list];

  return (
    <div className="relative overflow-hidden" data-testid="client-marquee">
      <div className="pointer-events-none absolute inset-y-0 left-0 w-20 bg-gradient-to-r from-[#FAFAFA] to-transparent z-10" aria-hidden="true" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-20 bg-gradient-to-l from-[#FAFAFA] to-transparent z-10" aria-hidden="true" />
      <div className="marquee-track flex gap-12 md:gap-16 items-center py-2">
        {track.map((c, i) => (
          <div key={`${c.name}-${i}`} className="shrink-0 w-[160px] md:w-[200px] h-16 md:h-20 flex items-center justify-center">
            <ClientLogo client={c} className="w-full h-full px-2" />
          </div>
        ))}
      </div>
    </div>
  );
}
